import { useBreakpointValue } from "@chakra-ui/react";

// ref: https://chakra-ui.com/docs/styled-system/theme#breakpoints
const LG_BREAKPOINT = 62 * 16;
const isInitiallyMobile = window.innerWidth < LG_BREAKPOINT;

export const useIsMobile = (): boolean => {
  return useBreakpointValue({ base: true, lg: false }) ?? isInitiallyMobile;
};
